export default __webpack_public_path__ + "images/64be9feb92497201a8419d5e1a434456.svg";